import type { ComponentType, SVGProps } from "react";

/**
 * FAB (floating action button) action registered by the active view.
 *
 * Each module view that wants a FAB calls `registerFab(...)` from a
 * useEffect on mount. The shell reads the current registration on every
 * render and renders a single shared FAB. Pages with no FAB simply
 * unregister on unmount.
 *
 * The icon is typed as a Lucide-compatible component (ComponentType of an
 * SVG with size 24 by default) so any lucide-react icon can be plugged in.
 */
export type FabAction = {
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>;
  onClick: () => void;
};

let current: FabAction | null = null;
const listeners = new Set<() => void>();

export function registerFab(action: FabAction | null) {
  current = action;
  listeners.forEach((l) => l());
}

export function getFab(): FabAction | null {
  return current;
}

export function subscribeFab(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
